<div class="layout">
  <div class="castle-container">
    <h1>{{ 'bounceCastle.title' | translate }}</h1>
    <div class="list">
      <div class="tile" *ngFor="let castle of bounceCastles">
        <mat-card class="castle-card">
          <img mat-card-image [src]="castle.img[0]" alt="Bild hier" fetchpriority="high">
          <div class="card-details">
            <mat-card-title>{{ castle.name | translate }}</mat-card-title>
            <span class="price-fraction">
              <mat-card-subtitle>{{ castle.price }}</mat-card-subtitle>
              <mat-card-subtitle class="fraction">{{ castle.fraction }}</mat-card-subtitle>
              <span class="material-symbols-outlined price-icon">euro_symbol</span>
            </span>
            <p class="cleaning-fee">
              <span>
                {{ 'cleaningFee.part1' | translate }} {{ castle.cleaningFee }}€ {{ 'cleaningFee.part2' | translate }}
              </span>
            </p>
            <button mat-flat-button (click)="openDialog(castle)">
              {{ 'bounceCastle.moreImages' | translate }}
            </button>
            <mat-card-content>
              <div class="metric">
                <span class="material-symbols-outlined">straighten</span>
                {{ castle.size }}
                <small class="dimension-hint">{{ 'bounceCastle.dimensionsHint' | translate }}</small>
              </div>
              <div class="metric">
                <span class="material-symbols-outlined">person</span>
                {{ castle.maxPeople | translate }}
              </div>
              <div class="metric">
                <span class="material-symbols-outlined">weight</span>
                {{ castle.weight }}
              </div>
              <div class="metric">
                <span class="material-symbols-outlined">mode_fan</span>
                {{ castle.fan }}
              </div>
              <div class="metric">
                <span class="material-symbols-outlined">power</span>
                {{ castle.engine }}
              </div>
              <div class="metric features-metric">
                <span class="material-symbols-outlined">family_star</span>
                {{ castle.features | translate }}
              </div>
            </mat-card-content>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>